import PvAutoComplete from 'primevue/autocomplete';
import PvChip from 'primevue/chip';
import PvButton from 'primevue/button';
import PvBadge from 'primevue/badge';
import PvDataTable from 'primevue/datatable';
import PvColumn from 'primevue/column';
import PvCard from 'primevue/card';
import PvCheckbox from 'primevue/checkbox';
import PvRadioButton from 'primevue/radiobutton';
import PvContextMenu from 'primevue/contextmenu';
import PvDynamicDialog from 'primevue/dynamicdialog';
import PvSelect from 'primevue/select';
import PvInputText from 'primevue/inputtext';
import PvInputNumber from 'primevue/inputnumber';
import PvMenu from 'primevue/menu';
import PvToast from 'primevue/toast';
import PvTooltip from 'primevue/tooltip';
import PvSelectButton from 'primevue/selectbutton';
import PvConfirmDialog from 'primevue/confirmdialog';
import PvKnob from 'primevue/knob';
import PvProgressBar from 'primevue/progressbar';
import PvEditor from 'primevue/editor';
import PvTimeline from 'primevue/timeline';
import PvTreeTable from 'primevue/treetable';
import PvTabMenu from 'primevue/tabmenu';
import PvTabs from 'primevue/tabs';
import PvTabList from 'primevue/tablist';
import PvTab from 'primevue/tab';
import PvTabPanels from 'primevue/tabpanels';
import PvTabPanel from 'primevue/tabpanel';
import PvChart from 'primevue/chart';
import PvMultiSelect from 'primevue/multiselect';
import PvTextarea from 'primevue/textarea';
import PvDatePicker from 'primevue/datepicker';
import PvToolbar from 'primevue/toolbar';
import PvSlider from 'primevue/slider';
import PvAvatar from 'primevue/avatar';
import PvMenubar from 'primevue/menubar';
import PvDrawer from 'primevue/drawer';
import PvPanelMenu from 'primevue/panelmenu';
import PvSplitter from 'primevue/splitter';
import PvSplitterPanel from 'primevue/splitterpanel';
import type { App, Component } from 'vue';

export const components: Record<string, Component> = {
  PvAutoComplete,
  PvChip,
  PvButton,
  PvBadge,
  PvDataTable,
  PvColumn,
  PvCard,
  PvCheckbox,
  PvRadioButton,
  PvContextMenu,
  PvDynamicDialog,
  PvSelect,
  PvInputText,
  PvInputNumber,
  PvMenu,
  PvSelectButton,
  PvToast,
  PvConfirmDialog,
  PvKnob,
  PvProgressBar,
  PvEditor,
  PvTimeline,
  PvTreeTable,
  PvTabMenu,
  PvTabs,
  PvTabList,
  PvTab,
  PvTabPanels,
  PvTabPanel,
  PvChart,
  PvMultiSelect,
  PvTextarea,
  PvDatePicker,
  PvToolbar,
  PvSlider,
  PvAvatar,
  PvMenubar,
  PvDrawer,
  PvPanelMenu,
  PvSplitter,
  PvSplitterPanel,
};

export function registerPrimeVueComponents(app: App) {
  Object.entries(components).forEach(([name, component]) => {
    app.component(name, component);
  });

  app.directive('tooltip', PvTooltip);
}
